const semanticTokens = {
  colors: {
    divider: {
      'default': 'blackAlpha.200',
      _dark: 'whiteAlpha.200',
    },
    text: {
      'default': 'blackAlpha.800',
      _dark: 'whiteAlpha.800',
    },
    text_secondary: {
      'default': 'gray.500',
      _dark: '#bbbbbb',
    },
    link: {
      'default': 'blue.600',
      _dark: 'blue.300',
    },
    link_hovered: {
      'default': 'blue.400',
    },
    icon_link_external: {
      'default': 'gray.300',
      _dark: 'gray.500',
    },
    icon_info: {
      'default': 'gray.400',
      _dark: 'gray.500',
    },
    error: {
      'default': 'red.500',
      _dark: 'red.500',
    },
    dialog_bg: {
      'default': 'white',
      _dark: 'gray.900',
    },

    // —— Tools sidebar (and any “tools” UI). Change here to affect light/dark globally.
    tools_heading: {
      'default': '#212529',
      _dark: 'white',
    },
    tools_link: {
      'default': '#000',
      _dark: 'gray.300',
    },
    tools_link_active: {
      'default': '#000',
      _dark: 'blue.400',
    },
    tools_link_active_bg: {
      'default': '#DEE2E6',
      _dark: 'whiteAlpha.200',
    },
    tools_link_hover_bg: {
      'default': '#f8f9fa',
      _dark: 'whiteAlpha.100',
    },
    tools_divider: {
      'default': '#e9ecef',
      _dark: 'gray.600',
    },

    // —— General tools page content (titles, descriptions, cards, buttons). Use across all tools.
    text_primary: {
      'default': '#212529',
      _dark: 'white',
    },
    text_muted: {
      'default': '#56595C',
      _dark: 'gray.400',
    },
    text_muted_secondary: {
      'default': '#6C757D',
      _dark: 'gray.400',
    },

    bg_gray: {
      'default': '#E9ECEF',
      _dark: 'gray.700',
    },

    text_gray: {
      'default': '#081d35',
      _dark: 'gray.400',
    },  
      

    text_label: {
      'default': '#000',
      _dark: 'gray.200',
    },
    link_accent: {
      'default': '#0784c3',
      _dark: 'blue.400',
    },
    card_bg: {
      'default': 'white',
      _dark: '#16161B',
    },
    card_border: {
      'default': '#e9ecef',
      _dark: '#383a40',
    },
    badge_bg: {
      'default': '#e8f4fd',
      _dark: 'blue.900',
    },
    radio_default: {
      'default': '#495057',
      _dark: 'gray.400',
    },
    button_outline_border: {
      'default': '#e9ecef',
      _dark: 'gray.600',
    },
    button_outline_hover: {
      'default': '#f8f9fa',
      _dark: 'gray.700',
    },
    result_bg: {
      'default': '#e8f4fd',
      _dark: 'blue.900',
    },
    result_border: {
      'default': '#b8daff',
      _dark: 'blue.700',
    },
    result_text: {
      'default': '#0c5460',
      _dark: 'cyan.200',
    },
    surface_muted: {
      'default': '#f8f9fa',
      _dark: 'gray.700',
    },
    gray_bg: {
      'default': '#E9ECEF',
      _dark: 'gray.700',
    },
    search_bar_bg: {
      'default': '#C3C7CD',
      _dark: 'gray.700',
    },

    // Result box: success (e.g. Verify Signatures)
    success_bg: {
      'default': '#d4edda',
      _dark: 'green.900',
    },
    success_border: {
      'default': '#c3e6cb',
      _dark: 'green.700',
    },
    success_text: {
      'default': '#155724',
      _dark: 'green.200',
    },
    // Result box: error
    error_bg: {
      'default': '#f8d7da',
      _dark: 'red.900',
    },
    error_border: {
      'default': '#f5c6cb',
      _dark: 'red.700',
    },
    error_text: {
      'default': '#721c24',
      _dark: 'red.200',
    },
    // Warning / info alert (e.g. yellow banner)
    warning_bg: {
      'default': '#ffeeba',
      _dark: 'yellow.900',
    },
    warning_text: {
      'default': '#856404',
      _dark: 'yellow.200',
    },
  },
  shadows: {
    action_bar: '0 4px 4px -4px rgb(0 0 0 / 10%), 0 2px 4px -4px rgb(0 0 0 / 6%)',
    card: '0 0.5rem 1.2rem rgb(189 197 209 / 20%)',
  },

  card: {
    default: '0 0.5rem 1.2rem rgb(189 197 209 / 20%)',
    _dark: '0 0 0 1px rgba(255,255,255,0.04), 0 6px 20px rgba(0,0,0,0.6)',
},



};

export default semanticTokens;
